export const SYSADMIN_SET_WORKSPACE_MODAL_LOCAL_STORAGE_KEY = 'air/sysadmin/recentlyUsed';
